var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovistaaLogoCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8819 3.36111C12.8819 1.50482 11.3678 0 9.5 0C7.63224 0 6.11813 1.50482 6.11813 3.36111C6.11813 5.2174 7.63224 6.72222 9.5 6.72222C11.3678 6.72222 12.8819 5.2174 12.8819 3.36111Z",
    fill: "#A74DAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45081 22H9.43851C8.45469 22 7.52621 21.5233 6.95437 20.7289L0.57799 11.9106C-0.411978 10.5417 -0.0983852 8.62889 1.27896 7.645C2.65631 6.66111 4.5809 6.97278 5.57087 8.34167L9.46925 13.7317L13.4414 8.32333C14.4437 6.96055 16.3683 6.66111 17.7395 7.65722C19.1107 8.65333 19.412 10.5661 18.4097 11.9289L11.9349 20.7472C11.357 21.5356 10.4346 22 9.45081 22Z",
    fill: "#A74DAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovistaaLogoCollapsed);
export default __webpack_public_path__ + "static/media/innovistaaLogoCollapsed.d67fcb49a4435fe0830767b9fdda9f6c.svg";
export { ForwardRef as ReactComponent };